export default {
  settings: null,
  settingsNameToCreate: '',
  settingsDeletionPending: [],
  settingsCreationPending: false
}
